export const LOADING_RATES_LIST = [
    {
        key: undefined,
        value: undefined,
        detailsDisabled: [
            'quantity', 'dimension', 'speed', 'term', 'abbreviation',
        ],
        detailsClear: true,
    },
    {
        key: 'LoadingRate',
        value: 'Loading rate',
        detailsDisabled: [],
        detailsClear: true,
        requiredFields: [
            'quantity', 'dimension',
        ],
    },
    {
        key: 'LoadingRateCQD',
        value: 'Loading rate - CQD',
        detailsDisabled: [
            'quantity', 'dimension',
        ],
        detailsClear: true,
    },
    {
        key: 'LoadingRateScale',
        value: 'Loading Rate - Scale',
        detailsDisabled: [
            'quantity', 'dimension',
        ],
        detailsClear: true,
    },
    {
        key: 'LRAsFastAsVesselCan',
        value: 'LR - As Fast as Vessel Can',
        detailsDisabled: [
            'quantity', 'dimension',
        ],
        detailsClear: true,
    },
    {
        key: 'LDRate',
        value: 'L/D Rate',
        detailsDisabled: [],
        dischargingDisabled: true,
        detailsClear: true,
        requiredFields: [
            'quantity', 'dimension',
        ],
    },
    {
        key: 'LDRatesTotalDays',
        value: 'L/D Rates - Total days',
        dischargingDisabled: true,
        detailsClear: true,
        detailsDisabled: [
            'dimension',
        ],
        fill: {
            field: 'dimension',
            value: 'days',
        },
    },
    {
        key: 'LDRatesTotalHours',
        value: 'L/D Rates - Total hours',
        dischargingDisabled: true,
        detailsClear: true,
        detailsDisabled: [
            'dimension', 
        ],
        fill: {
            field: 'dimension',
            value: 'hours',
        },
    },
];

export const DISCHARGING_RATES_LIST = [
    {
        key: undefined,
        value: undefined,
        detailsDisabled: [
            'quantity', 'dimension', 'speed', 'term', 'abbreviation',
        ],
        detailsClear: true,
    },
    {
        key: 'DischargingRate',
        value: 'Discharging rate',
        detailsDisabled: [],
        detailsClear: true,
        requiredFields: [
            'quantity', 'dimension',
        ],
    },
    {
        key: 'DischargingRateCQD',
        value: 'Discharging rate - CQD',
        detailsDisabled: [
            'quantity', 'dimension',
        ],
        detailsClear: true,
    },
    {
        key: 'DischargingRateScale',
        value: 'Discharging rate - Scale',
        detailsDisabled: [
            'quantity', 'dimension',
        ],
        detailsClear: true,
    },
    {
        key: 'DRAsFastAsVesselCan',
        value: 'DR - As Fast as Vessel Can',
        detailsDisabled: [
            'quantity', 'dimension', 
        ],
        detailsClear: true,
    },
];

export const RATE_FIELDS = {
    dimension: 'dimension',
    speed: 'speed',
    abbreviation: 'abbreviation',
    term: 'term',
};

export const LOADING_RATES_DEFAULT = LOADING_RATES_LIST[0];
export const DISCHARGING_RATES_DEFAULT = DISCHARGING_RATES_LIST[0];



// WEBPACK FOOTER //
// ./app/constants/ldRates.js